import React from "react";
import { Currency } from "./mmTypes";

interface Props {
  data: Currency[];
}

const CurrencyTable: React.FC<Props> = ({ data }) => {
  return (
    <div>
      {data.length > 0 ? (
        <table
          border={1}
          style={{
            width: "100%",
            borderCollapse: "collapse",
            boxShadow: "none",
          }}
        >
          <thead>
            <tr>
              <th>Currency Name</th>
              <th>Free</th>
              <th>Locked</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item.currency_name}</td>
                <td>{item.free}</td>
                <td>{item.locked}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div />
      )}
    </div>
    // <table border={1} style={{ width: "100%", borderCollapse: "collapse", boxShadow: "none" }}>
    //   <thead>
    //     <tr>
    //       <th>Currency Name</th>
    //       <th>Free</th>
    //       <th>Locked</th>
    //     </tr>
    //   </thead>
    //   <tbody>
    //     {data.map((item, index) => (
    //       <tr key={index}>
    //         <td>{item.currency_name}</td>
    //         <td>{item.free}</td>
    //         <td>{item.locked}</td>
    //       </tr>
    //     ))}
    //   </tbody>
    // </table>
  );
};

export default CurrencyTable;
